import { useEffect, useRef } from 'react';

export const useReverseScroll = () => {
  const containerRef = useRef<HTMLElement>();

  useEffect(() => {
    const el = containerRef.current;

    const invertedWheelScroll = (event) => {
      el.scrollTop -= event.deltaY;
      event.preventDefault();
    };

    el?.addEventListener('wheel', invertedWheelScroll, false);

    return () => el?.removeEventListener('wheel', invertedWheelScroll);
  }, []);

  return { ref: containerRef };
};
